module.exports = __webpack_public_path__ + "assets/573063f0c6e5e92aaa8f663e9842df53.png";